import request from '@/utils/request'

export function getOrderGoodsList (payload) {
  return request({
    url: '/api/seller/order_list',
    method: 'post',
    data: {
      type: payload.isOnSale,
      keyword: payload.keyword,
      page: payload.page
    }
  })
}
export function getOrderGoodsInfo (orderId) {
  return request({
    url: '/api/seller/order_detail',
    method: 'post',
    data: {
      order_id: orderId
    }
  })
}
export function editOrderGoods (data) {
  return request({
    url: '/api/seller/edit_order ',
    method: 'post',
    data: {
      data
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/order.js